export const XHR_BASE_PATH = '/_napi/da-browse/';
export const API_BASE_PATH = `${XHR_BASE_PATH}api`;
export const NETWORKBAR_API_BASE_PATH = `${XHR_BASE_PATH}api/networkbar`;
export const SHARED_API_BASE_PATH = `${XHR_BASE_PATH}shared_api`;

export const PAGE_STREAM_ID = '@@BROWSE_PAGE_STREAM';

export const DEFAULT_PAGE_SIZE = 24;

export enum ApiGetEndpoint {
  DailyDeviations = '/dailydeviations',
  Faceted = '/faceted',
  Tags = '/tags',
}

export enum ApiPostEndpoint {}

export enum Pages {
  Search = 'search',
  Faceted = 'faceted',
  Posts = 'posts',
  DailyDeviation = 'daily-deviation',
  Tag = 'tag',
  Topics = 'topics',
}

export enum ErrorNames {
  None = 'none',
  Request = 'request',
  HighOffset = 'highOffset',
  NoResults = 'noResults',
  PastEndOfResults = 'pastEndOfResults',
  AllMature = 'allMature',
  AllStored = 'allStored',
  AllDeleted = 'allDeleted',
  AllAntisocial = 'allAntisocial',
  HighLoad = 'highLoad',
  AllBlocked = 'allBlocked',
  NoDeviantsYouWatch = 'noDeviantsYouWatch',
  TagBlocked = 'tagBlocked',
}

export enum BiView {
  Search = 'search',
  Browse = 'browse',
}

export enum BrowseLayout {
  Torpedo = 1,
  Grid = 2,
  Feed = 3,
}
